import './index.css';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { ReactComponent as JayapranaLogo } from '@/assets/icons/jayaprana-logo.svg';
import Button from '@/components/common/Button';
import Input from '@/components/common/Input';
import { useAppDispatch } from '@/store';
import { resetPassword } from '@/store/password/action';

const renderModalForm = ({ methods }, onSubmit) => (
	<div className="flex flex-col items-start flex-grow p-10 gap-8 h-full">
		<div className="flex flex-col p-0 gap-1">
			<p className="font-bold text-2xl">Reset Password</p>
			<p className="text-sm text-grey-dark">Reset your password and re-login to enter the dashboard</p>
		</div>
		<FormProvider {...methods}>
			<form
				className="reset-password__modal-form__body"
				onSubmit={methods.handleSubmit(onSubmit)}
			>
				<div className="reset-password__modal-form__body-input">
					<Input
						name="password"
						label="New Password"
						type="password"
						expanded
						placeholder="Enter your new password"
						validationSchema={{ required: 'Please fill me' }}
					/>
					<Input
						name="confirmPassword"
						label="Re-type Password"
						type="password"
						expanded
						placeholder="Re-type your new password"
						validationSchema={{ required: 'Please fill me' }}
					/>
				</div>
				<div className="reset-password__modal-form__body-cta">
					{/* TODO: check preflight overwriting button's bg-color to transparent - btn-primary passed from parent for now */}
					<Button type="submit" variant="primary" className="w-full" onClick={() => onSubmit}>
						SUBMIT
					</Button>
				</div>
			</form>
		</FormProvider>
	</div>
);

const ResetPassword = (): JSX.Element => {
	const methods = useForm();
	const navigate = useNavigate();
	const [searchParams,] = useSearchParams();

	const dispatch = useAppDispatch();

	const onSubmit = async () => {
		const { password, confirmPassword } = methods.getValues();
		if (password !== confirmPassword) {
			return
		}
		try {
			dispatch(resetPassword({ password, token: searchParams.get('t')}))
			navigate('/login')
		} catch (e) {
			//TODO
		}
	};

	return (
		<div className="bg-black-primary w-full h-full">
			<div className="mix-blend-overlay opacity-75 absolute bg-[length:100%_100%] bg-[right_bottom_-4%] w-full h-full z-0 reset-password__overlay" />
			<div className="w-full h-full flex flex-col justify-center items-center relative">
				<div className="mb-12 text-white">
					<JayapranaLogo />
				</div>
				<div className="flex flex-row items-center self-center p-0 gap-3 rounded-md bg-white min-h-[40%] min-w-[20%]">
					{renderModalForm({ methods }, onSubmit)}
				</div>
			</div>
		</div>
	);
};

export default ResetPassword;
